export const MIN_RATE_NUMBER = 0;
export const MAX_RATE_NUMBER = Number.MAX_SAFE_INTEGER;
